module.exports = __webpack_public_path__ + "static/media/logo7.f0f2cf7d.png";